const STORAGE_KEY = "s2-loc-idx-cache";
const MAX_ENTRIES = 50;

type Entry = [string, number];

const readEntries = (): Entry[] => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter(
            (e): e is Entry => Array.isArray(e) && typeof e[0] === "string" && typeof e[1] === "number"
        );
    } catch {
        return [];
    }
};

const writeEntries = (entries: Entry[]): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
    } catch {
        // Quota exceeded or storage disabled — silently drop
    }
};

export const getLocationIndex = (orderNumber: string): number | null => {
    if (!orderNumber) return null;
    const entries = readEntries();
    const found = entries.find(([key]) => key === orderNumber);
    return found ? found[1] : null;
};

export const setLocationIndex = (orderNumber: string, index: number): void => {
    if (!orderNumber) return;
    const entries = readEntries().filter(([key]) => key !== orderNumber);
    entries.push([orderNumber, index]);
    while (entries.length > MAX_ENTRIES) entries.shift();
    writeEntries(entries);
};

export const clearLocationCache = (): void => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
};
